module.exports = __webpack_public_path__ + "static/Branding-969b99e749435e4c87b51a04371c373e.svg";